/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: octokit-provider.ts
 * Project: mle-client
 * Committed last: 2021/11/12 @ 1217
 * ---
 */

import { Octokit } from 'octokit';

/**
 * Gestisce la generazione di istanze per l'SDK AiO per GitHub, Octokit.
 * Opera secondo la logica descritta dal pattern Singleton [GoF]
 */
export class OctokitProvider {
  /**
   * Istanza corrente dell'SDK
   * @type {Octokit}
   */
  static instance: Octokit;

  /**
   * Permette al costruttore di eseguito solo da questa classe o suoi eredi
   * @protected
   */
  protected constructor() {}

  /**
   * Secondo il pattern Singleton [GoF], si assicura che nell'ambiente di esecuzione,
   * sia presente una sola istanza della classe.
   * @returns {Octokit}
   */
  static getInstance() {
    if (!OctokitProvider.instance)
      OctokitProvider.instance = new Octokit({ auth: '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' });
    return OctokitProvider.instance;
  }
}
